import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {
    AlgorithmicDmvAcceptRequest,
    AlgorithmicDmvApiService,
    AlgorithmicDmvAssetSelectionRow,
    AlgorithmicDmvBulkAcceptOutcome,
    AlgorithmicDmvJobDetail,
    AlgorithmicDmvJobInfo,
    AlgorithmicDmvRequest
} from "../generated-sources/api";

@Injectable({providedIn: "root"})
export class AlgorithmicDmvService {

    private readonly api = inject(AlgorithmicDmvApiService);

    start(fundId: number, request: AlgorithmicDmvRequest): Observable<number> {
        return this.api.startAlgorithmicDmv(fundId, request);
    }

    getJobsForFund(fundId: number): Observable<AlgorithmicDmvJobInfo[]> {
        return this.api.getAlgorithmicDmvJobsForFund(fundId);
    }

    getJobDetail(taskInfoId: number): Observable<AlgorithmicDmvJobDetail> {
        return this.api.getAlgorithmicDmvJobDetail(taskInfoId);
    }

    acceptResult(resultId: number, request: AlgorithmicDmvAcceptRequest): Observable<unknown> {
        return this.api.acceptAlgorithmicDmvResult(resultId, request);
    }

    skipResult(resultId: number): Observable<unknown> {
        return this.api.skipAlgorithmicDmvResult(resultId);
    }

    acceptAllSuggestions(taskInfoId: number): Observable<AlgorithmicDmvBulkAcceptOutcome> {
        return this.api.acceptAllAlgorithmicDmvSuggestions(taskInfoId);
    }

    getAssetSelection(fundId: number, fundValuationId: number): Observable<AlgorithmicDmvAssetSelectionRow[]> {
        return this.api.getAlgorithmicDmvAssetSelection(fundId, fundValuationId);
    }
}
